import {
  getDiscountCombinations,
  getExpirationDuration,
  getExtraValueTypeChanges,
} from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/RefundMethod/RefundMethodContent/helpers'

const useRefundMethodContent = ({ refundMethod, savedRefundMethod, onChange }) => {
  const handleChangeCustomName = (value, language) => {
    onChange(refundMethod.id, { display: { ...refundMethod.display, [language]: value } })
  }

  const handleToggleCustomName = event => {
    onChange(refundMethod.id, { useCustomName: event.target.checked })
  }

  const handleChangeInstantAllowed = value => {
    if (savedRefundMethod.instant_allowed === undefined) return

    onChange(refundMethod.id, { instant_allowed: value })
  }

  const handleChangeDurationNumber = event => {
    if (event.target.value >= 0)
      onChange(refundMethod.id, { duration: { ...refundMethod.duration, number: event.target.value } })
  }

  const handleChangeDurationType = event => {
    onChange(refundMethod.id, { duration: { ...refundMethod.duration, type: event.target.value } })
  }

  const handleToggleExpiration = value => {
    onChange(refundMethod.id, { duration: getExpirationDuration(value) })
  }

  const handleChangeExtraValueType = event => {
    onChange(refundMethod.id, getExtraValueTypeChanges(event.target.value))
  }

  const handleChangeExtraValue = event => {
    if (event.target.value >= 0) onChange(refundMethod.id, { extra_value: event.target.value })
  }

  const handleChangeMinEligibleRefundAmount = event => {
    if (event.target.value >= 0) onChange(refundMethod.id, { min_eligible_refund_amount: event.target.value })
  }

  const handleChangeMaxExtraAmount = event => {
    if (event.target.value >= 0) onChange(refundMethod.id, { max_extra_amount: event.target.value })
  }

  const handleChangeAllowExtraWhenPaidWithCredit = event => {
    onChange(refundMethod.id, { allow_extra_when_paid_with_credit: event.target.checked })
  }

  const handleChangeDiscountCombinations = (discountType, checked) => {
    onChange(refundMethod.id, {
      discount_combinations: getDiscountCombinations(refundMethod.discount_combinations, discountType, checked),
    })
  }

  return {
    handleChangeCustomName,
    handleToggleCustomName,
    handleChangeInstantAllowed,
    handleChangeDurationNumber,
    handleChangeDurationType,
    handleToggleExpiration,
    handleChangeExtraValueType,
    handleChangeExtraValue,
    handleChangeMinEligibleRefundAmount,
    handleChangeMaxExtraAmount,
    handleChangeAllowExtraWhenPaidWithCredit,
    handleChangeDiscountCombinations,
  }
}

export default useRefundMethodContent
